<template>
    <div class="tag-records-container" :style="{'--primary-color': query.payType == '支出' ? '#3eb475' : '#eeb63b', '--primary-color-bg': query.payType == '支出' ? 'rgba(62, 180, 117, .2)' : 'rgba(238, 182, 59, .2)'}">
        <div class="tag-records-header">
            <div class="header-title">{{query.payDate}}{{query.tag}}共{{query.payType}}</div>
            <div class="header-price">
                <span>{{tagInfoData.money}}</span>
                <span class="price-yuan">元</span>
            </div>
        </div>
        <div class="tag-records-content">
            <div class="content-list">
                <div class="list-item" @click="handleSort">
                    <div class="item-btn" :class="query.orderByTime == 0 ? 'item-btn-active' : ''">按金额</div>
                    <div class="item-btn" :class="query.orderByTime == 1 ? 'item-btn-active' : ''">按时间</div>
                </div>
                <div class="list-item" v-for="(item, index) in tagInfoData.recordInfoVoList" :key="'tag_info_' + index">
                    <div class="item-index">{{index + 1}}</div>
                    <div class="item-info">
                        <div class="info-left">
                            <div class="left-title">{{item.cause}}</div>
                            <div class="left-date">{{item.payTime}}</div>
                        </div>
                        <div class="info-right">{{(item.payType == '收入' || item.money > 0 ? '+' : '') + item.money}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getPaymentReportsTagInfo} from "@/api/payment";

export default {
    name: "index",
    inject: ['setLoading'],
    data() {
        return {
            query: {
                payDate: '',
                payType: '',
                tag: '',
                orderByTime: 0
            },
            tagInfoData: {
                money: 0,
                recordInfoVoList: []
            }
        }
    },
    created() {
        this.query = Object.assign(this.query, this.$route.query)
        this.getData()
    },
    methods: {
        getData() {
            this.setLoading(true)
            getPaymentReportsTagInfo({
                date: this.query.payDate,
                payType: this.query.payType,
                tag: this.query.tag,
                orderByTime: this.query.orderByTime
            }).then(res => {
                this.tagInfoData = res.data
            }).finally(() => {
                this.setLoading(false)
            })
        },
        handleSort() {
            this.query.orderByTime = this.query.orderByTime == 0 ? 1 : 0
            this.getData()
        }
    }
}
</script>

<style lang="less" scoped>
.tag-records-container {
    min-height: 100vh;
    padding-bottom: 90px;
    .tag-records-header {
        padding: 40px 0 30px 0;
        text-align: center;
        border-bottom: 6px solid #f8f8f9;
        .header-title {
            line-height: 30px;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.5);
        }
        .header-price {
            font-size: 36px;
            color: #444;
            font-weight: 500;
            color: var(--primary-color);
            .price-yuan {
                padding-left: 10px;
                font-size: 16px;
                color: rgba(0, 0, 0, 0.7);
           }
        }
    }
    .tag-records-content {
        .content-list {
            padding: 10px 25px;
            .list-item {
                display: flex;
                align-items: center;
                padding: 20px 0;
                border-bottom: 1px solid #eee;
                .item-btn {
                    font-size: 16px;
                    margin-right: 10px;
                    padding: 5px 10px;
                    border-radius: 3px;
                    color: #aeaeaf;
                    background: rgba(174, 174, 175, 0.1);
                }
                .item-btn-active {
                    color: var(--primary-color);
                    background: var(--primary-color-bg);
                }
                .item-index {
                    text-align: center;
                    font-size: 16px;
                    width: 40px;
                    color: #999;
                }
                .item-info {
                    display: flex;
                    justify-content: space-between;
                    width: calc(100% - 40px);
                    .info-left {
                        width: calc(100% - 90px);
                        .left-title {
                            font-size: 16px;
                            color: #444;
                            line-height: 25px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .left-date {
                            font-size: 14px;
                            color: rgba(0, 0, 0, 0.3);
                            line-height: 25px;
                        }
                    }
                    .info-right {
                        text-align: right;
                        font-size: 16px;
                        color: #444;
                        font-weight: 500;
                        padding: 0 5px;
                        color: var(--primary-color);
                    }
                }
            }
        }
    }
}

</style>
